/**
 * Analytics Portal V1 — Personal Profile Analytics (Phase 11, plan §4.3 + §11 endpoint 4).
 * A pure renderer of `GET /api/analytics/profile` through the shared entity dashboard.
 */
import React from "react";
import { EntityDashboard } from "@/components/analytics/EntityDashboard";
import { NamedVisitorPanel } from "@/components/analytics/NamedVisitorPanel";
import { PROFILE_GROUPS, PROFILE_HEADLINE } from "@/components/analytics/profileMetrics";
import { useAnalyticsPortal } from "./AnalyticsPortal";

export default function ProfileTab() {
  const portal = useAnalyticsPortal();
  return (
    <EntityDashboard
      portal={portal}
      testId="analytics-view-profile"
      scopeType="personal"
      headline={PROFILE_HEADLINE}
      groups={PROFILE_GROUPS}
      funnelTitle="Profile conversion funnel"
      noActivityBody="This profile's analytics will populate once eligible activity is collected."
      afterGroups={portal?.payload && (
        <NamedVisitorPanel entityType="personal" entityId={portal.entity}
                           capabilities={portal.payload.capabilities} range={portal.range} />
      )}
    />
  );
}
